var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isCart)?_c(_setup.ReactWrapper,{attrs:{"component":_setup.shoppingCartPrice,"variant":_vm.variant},on:{"priceChange":_setup.handlePriceChange}}):_c(_setup.ReactWrapper,{attrs:{"component":_setup.price,"variant":_vm.variant},on:{"priceChange":_setup.handlePriceChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }